import PropTypes from 'prop-types'
import React from "react"
import { Modal, ModalBody } from "reactstrap"

const UnlockAccountConfirmationModal = ({  isOpen, onUnlockAccountClick, onCloseClick }) => {
  return (
    <Modal size="md"  isOpen={isOpen} toggle={onCloseClick} centered={true} backdrop="static">
      <div className="modal-content">
        <ModalBody className="px-4 py-5 text-center">
          <button type="button" onClick={onCloseClick} className="btn-close position-absolute end-0 top-0 m-3"></button>
          <div className="avatar-sm mb-4 mx-auto">
            <div className="avatar-title bg-primary text-primary bg-opacity-10 font-size-20 rounded-3">
              <i className="bx bx-lock-open"></i>
            </div>
          </div>
          <p className="text-muted font-size-16 mb-4">Etes-vous sûr de vouloir activer ce compte ?</p>

          <div className="hstack gap-2 justify-content-center mb-0">
            <button type="button" className="btn btn-danger" onClick={onUnlockAccountClick}>Activer</button>
            <button type="button" className="btn btn-secondary" onClick={onCloseClick}>Fermer</button>
          </div>
        </ModalBody>
      </div>
    </Modal>
  )
}

UnlockAccountConfirmationModal.propTypes = {
  onCloseClick: PropTypes.func,
  onUnlockAccountClick: PropTypes.func,
  isOpen: PropTypes.any
}

export default UnlockAccountConfirmationModal